import React, { Component } from 'react';
import Hidden from '@mui/material/Hidden';
import styles from '../Layout.module.css';
import i18n from 'i18n/I18nInstance';
import _ from 'classnames';

interface IProps {
    brandName: string;
}

class Header extends Component<IProps> {
    componentDidMount() {
        document.title = this.props.brandName;
    }

    render() {
        const i18n_title = i18n.translator.formatMessage({
            id: 'header.Title',
            defaultMessage: 'Resources',
        });

        return (
            <div>
                <div className={_(styles.noPrint, styles.NavBar)}>
                    <Hidden xsDown>
                        <span
                            data-qaid="appNameText"
                            className={styles.HeadlineV1}
                            aria-label={this.props.brandName}
                        >
                            {this.props.brandName}
                        </span>
                        <span data-qaid="headerDividerText" className={styles.Divider}>
                            |
                        </span>
                    </Hidden>
                    <div className={styles.HeadlineV2}>
                        <span data-qaid="pageTitleText" aria-label={i18n_title}>
                            {i18n_title}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;
